const DEFAULT_RECEIVER = 'customer.service@anedik.com.gr';

export const EMAIL_SUBJECTS_MAP = {
  kritikos: {
    order: { value: DEFAULT_RECEIVER, label: 'Για την παραγελία μου' },
    shop: { value: DEFAULT_RECEIVER, label: 'Για ένα κατάστημα' },
    default: { value: DEFAULT_RECEIVER, label: 'Γενικά' },
    franchise: { value: 'franchise@anedik.com.gr', label: 'Franchise' },
    career: { value: 'cv@anedik.com.gr', label: 'Εργασία' },
  },
  ariadni: {
    order: { value: DEFAULT_RECEIVER, label: 'Για την παραγελία μου' },
    shop: { value: DEFAULT_RECEIVER, label: 'Για ένα κατάστημα' },
    default: { value: DEFAULT_RECEIVER, label: 'Γενικά' },
    franchise: { value: 'franchise@anedik.com.gr', label: 'Franchise' },
    career: { value: 'cv@anedik.com.gr', label: 'Εργασία' },
  },
};
